import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import SectionCard from './ui/SectionCard';
import EmptyState from './ui/EmptyState';
import Pot from './Pot';
import api from '../api';

// Consulta o voto (potes) de um jogador específico.
const VotePlayer = ({ torneioId }) => {
  const [jogadorSelectd, setJogadorSelect] = useState(null);
  const [players, setPlayers] = useState([]);
  const [potes, setPotes] = useState({});
  const [renderPotes, setRenderPotes] = useState(false);

  const getPotesPlayer = async (jogador) => {
    try {
      const request = { torneio_id: torneioId, jogador: jogador }
      const response = await api.post('report/getPotesUser', request);
      setPotes(response.data)
      setRenderPotes(true)
    } catch (error) {
      setPotes({})
      setRenderPotes(false)
      console.error('Erro ao obter jogadores:', error);
    }
  }

  const selectPlayer = async (jogador) => {
    setJogadorSelect(jogador);
    if (jogador) await getPotesPlayer(jogador)
  }

  useEffect(() => {
    api
      .get('get-players')
      .then((response) => setPlayers(response.data.map((p) => p.nome).sort()))
      .catch((error) => console.error('Erro ao obter jogadores:', error));
  }, [])

  return (
    <SectionCard title="Voto por jogador" subtitle="Veja como cada jogador montou os potes (liberado após o prazo).">
      <Autocomplete
        options={players}
        value={jogadorSelectd}
        onChange={(e, value) => selectPlayer(value)}
        renderInput={(params) => <TextField {...params} label="Jogador" />}
        sx={{ maxWidth: 420, mb: 3 }}
      />
      {renderPotes ? (
        <Grid container spacing={2}>
          {Object.keys(potes).map((potNum) => (
            <Grid item xs={12} sm={6} md={4} lg={2} key={potNum}>
              <Pot potNum={potNum} playersInPot={potes[potNum]} />
            </Grid>
          ))}
        </Grid>
      ) : jogadorSelectd ? (
        <EmptyState title="Voto indisponível" description="Usuário não votou ou o prazo ainda não foi concluído." />
      ) : null}
    </SectionCard>
  );
};

export default VotePlayer;
